export const LINKS = [
  [
    {
      url: '/about',
      title: 'footer.links.about'
    },
    {
      url: '/marketing',
      title: 'common.advertising'
    },
    {
      url: '/privacy-policy',
      title: 'common.privacy_policy'
    },
    {
      url: '/contacts',
      title: 'common.feedback'
    },
    {
      url: '/application',
      title: 'common.app_kypc'
    },
    {
      url: '/authors',
      title: 'common.authors'
    }
  ],
  [
    {
      url: '/banks-info',
      title: 'common.for_banks'
    },
    {
      url: '/clients-info',
      title: 'common.for_clients'
    },
    {
      url: '/developers',
      title: 'common.for_developers'
    },
    {
      url: '/cooperation',
      title: 'common.cooperation'
    },
    {
      url: '/rates',
      title: 'footer.links.rates'
    },
    {
      url: '/vacancies',
      title: 'footer.links.vacancies'
    },
    {
      url: '/guarantee-fund',
      title: 'common.guarantee_fund'
    }
  ],
  [
    {
      url: '/news',
      title: 'common.news'
    },
    {
      url: '/news/category/crypto',
      title: 'common.crypto_news'
    },
    {
      url: '/useful-articles',
      title: 'common.useful_materials'
    },
    {
      url: '/quiz',
      title: 'page.quiz.breadcrumb'
    },
    {
      url: '/events',
      title: 'common.events'
    },
    {
      url: '/discussions',
      title: 'common.discussions'
    },
    {
      url: '/faq',
      title: 'footer.links.faq'
    },
    {
      url: '/glossary',
      title: 'footer.links.glossary'
    }
  ]
]

export const APP_LINKS = [
  {
    name: 'App Store',
    image: '/images/app-market/app-store.png',
    url: 'https://www.apple.com/app-store'
  },
  {
    name: 'Google Play',
    image: '/images/app-market/google-play.png',
    url: 'https://play.google.com/store/apps'
  }
]

export const SOCIAL_LINKS = [
  {
    url: 'https://www.facebook.com/portal.banks.kg',
    title: 'Facebook',
    className: 'hover:text-facebook',
    path: 'M15.1742 5.40796H17V2.22827C16.6856 2.1853 15.6023 2.08765 14.3409 2.08765C11.7083 2.08765 9.9053 3.7439 9.9053 6.78687V9.58765H7V13.1423H9.9053V22.0876H13.4659V13.1423H16.2538L16.697 9.58765H13.4659V7.13843C13.4659 6.11108 13.7424 5.40796 15.1742 5.40796Z'
  },
  {
    url: 'https://www.instagram.com/banks.kg',
    title: 'instagram',
    className: 'hover:text-instagram',
    path: 'M13.028 2.08765C14.153 2.09065 14.724 2.09665 15.217 2.11065L15.411 2.11765C15.635 2.12565 15.856 2.13565 16.123 2.14765C17.187 2.19765 17.913 2.36565 18.55 2.61265C19.21 2.86665 19.766 3.21065 20.322 3.76565C20.8307 4.26538 21.2242 4.87012 21.475 5.53765C21.722 6.17465 21.89 6.90065 21.94 7.96565C21.952 8.23165 21.962 8.45265 21.97 8.67765L21.976 8.87165C21.991 9.36365 21.997 9.93465 21.999 11.0596L22 11.8056V13.1156C22.0025 13.8451 21.9948 14.5745 21.977 15.3036L21.971 15.4976C21.963 15.7226 21.953 15.9436 21.941 16.2096C21.891 17.2746 21.721 17.9996 21.475 18.6376C21.2242 19.3052 20.8307 19.9099 20.322 20.4096C19.8223 20.9183 19.2175 21.3118 18.55 21.5626C17.913 21.8096 17.187 21.9776 16.123 22.0276L15.411 22.0576L15.217 22.0636C14.724 22.0776 14.153 22.0846 13.028 22.0866L12.282 22.0876H10.973C10.2433 22.0902 9.51354 22.0826 8.78402 22.0646L8.59002 22.0586C8.35263 22.0497 8.11529 22.0393 7.87802 22.0276C6.81402 21.9776 6.08802 21.8096 5.45002 21.5626C4.78285 21.3117 4.17846 20.9182 3.67902 20.4096C3.16996 19.91 2.77613 19.3053 2.52502 18.6376C2.27802 18.0006 2.11002 17.2746 2.06002 16.2096L2.03002 15.4976L2.02502 15.3036C2.00659 14.5745 1.99825 13.8451 2.00002 13.1156V11.0596C1.99725 10.3302 2.00459 9.60084 2.02202 8.87165L2.02902 8.67765C2.03702 8.45265 2.04702 8.23165 2.05902 7.96565C2.10902 6.90065 2.27702 6.17565 2.52402 5.53765C2.77571 4.86984 3.17024 4.26508 3.68002 3.76565C4.17917 3.2572 4.78321 2.86372 5.45002 2.61265C6.08802 2.36565 6.81302 2.19765 7.87802 2.14765C8.14402 2.13565 8.36602 2.12565 8.59002 2.11765L8.78402 2.11165C9.51321 2.09388 10.2426 2.08621 10.972 2.08865L13.028 2.08765ZM12 7.08765C10.6739 7.08765 9.40217 7.61443 8.46449 8.55211C7.5268 9.48979 7.00002 10.7616 7.00002 12.0876C7.00002 13.4137 7.5268 14.6855 8.46449 15.6232C9.40217 16.5609 10.6739 17.0876 12 17.0876C13.3261 17.0876 14.5979 16.5609 15.5356 15.6232C16.4732 14.6855 17 13.4137 17 12.0876C17 10.7616 16.4732 9.48979 15.5356 8.55211C14.5979 7.61443 13.3261 7.08765 12 7.08765ZM12 9.08765C12.394 9.08758 12.7841 9.16511 13.1481 9.31582C13.5121 9.46652 13.8429 9.68744 14.1215 9.96597C14.4001 10.2445 14.6211 10.5752 14.772 10.9391C14.9228 11.3031 15.0005 11.6932 15.0005 12.0871C15.0006 12.4811 14.9231 12.8712 14.7723 13.2352C14.6216 13.5992 14.4007 13.93 14.1222 14.2086C13.8437 14.4872 13.513 14.7083 13.149 14.8591C12.7851 15.0099 12.395 15.0876 12.001 15.0876C11.2054 15.0876 10.4423 14.7716 9.8797 14.209C9.31709 13.6464 9.00102 12.8833 9.00102 12.0876C9.00102 11.292 9.31709 10.5289 9.8797 9.96633C10.4423 9.40372 11.2054 9.08765 12.001 9.08765M17.251 5.58765C16.9195 5.58765 16.6016 5.71934 16.3671 5.95376C16.1327 6.18818 16.001 6.50613 16.001 6.83765C16.001 7.16917 16.1327 7.48711 16.3671 7.72153C16.6016 7.95595 16.9195 8.08765 17.251 8.08765C17.5825 8.08765 17.9005 7.95595 18.1349 7.72153C18.3693 7.48711 18.501 7.16917 18.501 6.83765C18.501 6.50613 18.3693 6.18818 18.1349 5.95376C17.9005 5.71934 17.5825 5.58765 17.251 5.58765Z'
  },
  {
    url: 'https://t.me/Banks_KG',
    title: 'Telegram',
    className: 'hover:text-telegram',
    path: 'M22.9373 5.54424L19.6174 19.1218C19.3669 20.0801 18.7137 20.3186 17.7855 19.8671L12.727 16.6346L10.2862 18.6704C10.0161 18.9046 9.79016 19.1005 9.26958 19.1005L9.633 14.6329L19.0084 7.28615C19.416 6.97099 18.92 6.79637 18.3749 7.11154L6.78454 13.4404L1.7948 12.086C0.70944 11.7921 0.689795 11.1448 2.02072 10.6933L21.5376 4.17285C22.4413 3.87898 23.232 4.34747 22.9373 5.54424Z'
  },
  {
    url: 'https://x.com/banks_kg',
    title: 'Twitter',
    className: 'hover:text-twitter',
    path: 'M3.114 3.08765H8.415L13.1325 9.83465L18.795 3.08765H20.4885L13.7775 10.7586L21 21.0876H15.702L10.7745 14.0421L4.692 21.0876H3L10.1295 13.1196L3.114 3.08765Z'
  }
]
